
<div class="col-12">
    <h3 class="mt-5">
        Si necesita ayuda o requiere información personalizada, contáctenos a nuestro WhatsApp.
    </h3>
    <br>
    <a class="btn mx-3 mt-4 text-center pb-1 btn-social bg-whatsapp text-white"
       href="{{href}}" target="_blank">
        <i class="fa fa-whatsapp"></i>      Whatsapp          
    </a>
</div>